interface Config {
  onOpen?: AnyFunc;
  onError?: AnyFunc;
  onClose?: AnyFunc;
  onMessage?: AnyFunc;
  maxConnectNum: number;
}
import { message } from 'antd';

export default class WebSocketClient {
  socket: any;
  config: Config;
  socketCloseCount: number = 0;
  maxConnectNum: number;
  wsUrl: string;
  token: string | undefined;
  constructor(wsUrl: string, config: Config, token?: string) {
    this.socket = new WebSocket(wsUrl, token);
    this.wsUrl = wsUrl;
    this.token = token;
    this.config = config;
    this.maxConnectNum = this.config.maxConnectNum;
    this.initSocket();
  }
  initSocket() {
    const { onOpen, onError, onClose, onMessage } = this.config;
    this.socket.onopen = () => {
      onOpen && onOpen();
    };
    this.socket.onerror = (err: any) => {
      onError && onError(err);
    };
    this.socket.onclose = (data: any) => {
      onClose && onClose(data);
      if (this.socketCloseCount > this.maxConnectNum) {
        this.socketCloseCount = 0;
        if (
          window.location.pathname === '/app/realtime' ||
          window.location.pathname === '/app/single'
        )
          message.warning('ws断开次数过多，请刷新页面重试！', 0);
        return;
      }
      this.socketCloseCount++;
      return setTimeout(() => {
        this.reConnect();
      }, 1000);
    };
    this.socket.onmessage = (data: any) => {
      onMessage && onMessage(data);
    };
  }

  reConnect() {
    this.socket = new WebSocket(this.wsUrl, this.token);
    this.initSocket();
  }
  sendMessage(data: any) {
    if (data && this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(data);
    }
  }
  closeSocket() {
    if (this.socket) {
      this.socket.close();
    }
  }
}
